export function useScreeningReportState(screeningReportData, setScreeningReportData) {
  const addToExportLog = (exportLogEntry) => {
    setScreeningReportData((prev) => ({
      ...prev,
      exportLog: [...(prev?.exportLog || []), exportLogEntry],
    }))
  }

  const addToFeedbackLog = (feedbackLogEntry) => {
    setScreeningReportData((prev) => ({
      ...prev,
      feedbackLog: [...(prev?.feedbackLog || []), feedbackLogEntry],
    }))
  }

  const hasExportLog = () => {
    return screeningReportData?.exportLog && screeningReportData.exportLog.length > 0
  }

  const hasFeedbackLog = () => {
    return screeningReportData?.feedbackLog && screeningReportData.feedbackLog.length > 0
  }

  return {
    addToExportLog,
    addToFeedbackLog,
    hasExportLog,
    hasFeedbackLog,
  }
} 